import { ThemeProvider, createTheme } from '@mui/material/styles';
import { Route, Routes } from 'react-router-dom';
import RegisterNumber from './register-number/RegisterNumber';
import RegisterEmail from './register-email/RegisterEmail';
import VerifyEmail from './verify-email/VerifyEmail';
import TopNav from '../../components/top-nav/TopNav';
import Footer from '../../components/Footer';
import VerifyOrgEmail from './verify-org-email/VerifyOrgEmail';

const Register = () => {
  const theme = createTheme({
    palette: {
      primary: {
        main: '#0884ff'
      },
      secondary: {
        main: '#73768c'
      }
    },
    typography: {
      button: {
        textTransform: 'capitalize'
      }
    }
  });
  return (
    <ThemeProvider theme={theme}>
      <TopNav />
      <Routes>
        <Route path="/" element={<RegisterEmail />} />
        <Route path="/register-user" element={<RegisterEmail />} />
        <Route path="/verify-email" element={<VerifyEmail />} />
        <Route path="/register-number" element={<RegisterNumber />} />
        <Route path="/verify-organisation-email" element={<VerifyOrgEmail />} />
      </Routes>
      <Footer />
    </ThemeProvider>
  );
};

export default Register;
